// extracted by mini-css-extract-plugin
export var icon = "_7v-1";
export var subtext = "_7v-0";